export default __webpack_public_path__ + "static/media/FORM_TOP_NEW_IMAGE_.59f759ec.png";